import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type GavelIconProps = { fillColor?: string } & IconProps;

export const GavelIcon: FC<GavelIconProps> = ({
  iconColor = '#F79009',
  fillColor = '#FEF0C7',
  className,
  ...props
}) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 10L20.383 17.418C21.206 18.238 21.206 19.566 20.383 20.385C19.9876 20.7783 19.4527 20.999 18.895 20.999C18.3373 20.999 17.8024 20.7783 17.407 20.385L10 13"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.3"
    />
    <path
      d="M3.207 12.207L6.793 15.793C6.98053 15.9805 7.23484 16.0858 7.5 16.0858C7.76516 16.0858 8.01947 15.9805 8.207 15.793L10.5 13.5L10 13L13 10L13.5 10.5L15.793 8.207C15.9805 8.01947 16.0858 7.76516 16.0858 7.5C16.0858 7.23484 15.9805 6.98053 15.793 6.793L12.207 3.207C12.0195 3.01953 11.7652 2.91421 11.5 2.91421C11.2348 2.91421 10.9805 3.01953 10.793 3.207L8.5 5.5L9 6L6 9L5.5 8.5L3.207 10.793C3.01953 10.9805 2.91421 11.2348 2.91421 11.5C2.91421 11.7652 3.01953 12.0195 3.207 12.207Z"
      fill={fillColor}
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.3"
    />
    <path
      d="M6 9L10 13M13 10L9 6M3 21H10"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.3"
    />
  </svg>
);
